module.exports = __webpack_public_path__ + "static/media/termelouzem_iroda_kialakitas.9bcb87e9.jpg";